var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
export const TimeOption = (_a) => {
    var { active, onSelect } = _a, props = __rest(_a, ["active", "onSelect"]);
    const [value, setValue] = React.useState(props.default);
    const inputRef = React.useRef(null);
    const { type, label, unit } = props;
    const isMonth = unit === null || unit === void 0 ? void 0 : unit.includes("month");
    React.useEffect(() => {
        if (props.default !== value) {
            onSelect(value);
        }
    }, [value]);
    return (React.createElement("div", { className: ["tnic-timeOption", active && "tnic-timeOption--active"]
            .filter(Boolean)
            .join(" "), onClick: () => {
            var _a;
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            onSelect(value);
        } },
        type === "input" && (React.createElement(React.Fragment, null,
            React.createElement("span", null,
                "Last",
                React.createElement("input", { className: "tnic-input", ref: inputRef, type: "text", value: value, onFocus: (e) => e.target.select(), onChange: (e) => setValue(e.target.value) }),
                unit),
            React.createElement("span", { className: "tnic-hovertext" }, "Click to select or edit"))),
        type === "fixed" && (React.createElement(React.Fragment, null,
            React.createElement("span", null, label),
            React.createElement("span", { className: "tnic-hovertext" }, "Click to select"))),
        type === "select" && (React.createElement(React.Fragment, null,
            React.createElement("span", null,
                label,
                ":",
                React.createElement("input", { className: "tnic-input tnic-input-large", ref: inputRef, type: "number", value: value, max: isMonth ? 12 : undefined, min: "1", onFocus: (e) => e.target.select(), onChange: (e) => setValue(e.target.value) }),
                isMonth && (React.createElement(React.Fragment, null, new Date(0, value, 0).toLocaleString("default", {
                    month: "short",
                })))),
            React.createElement("span", { className: "tnic-hovertext" }, "Click to select")))));
};
//# sourceMappingURL=TimeOption.js.map